module.exports = __webpack_public_path__ + "img/mobile-gear-1-high.3ec51453.png";